export type Tag = {
    id: number;
    label: string;
    description: string;
    count: number;
};

export function newTag(name = "", description = ""): Tag {
    const tag: Tag = {
        id: -1,
        label: name,
        description: description,
        count: 0,
    };

    return tag;
}
